import { EST_TIME_ZONE } from '@helpers/utils/asset-price/asset-price';
import { toZonedTime } from 'date-fns-tz';

type ThemeTimeseries = { value: number; index: string }[] | undefined;

const toMarketTime = (date: string | number) =>
  toZonedTime(new Date(date), EST_TIME_ZONE);

export const toChartPoints = (tsData: ThemeTimeseries, isIntraday: boolean) =>
  tsData?.map(point => ({
    value: point.value,
    date: isIntraday ? toMarketTime(point.index) : new Date(point.index),
  })) ?? [];

/**
 * Fixed 9:30 AM–4:00 PM ET x-axis for the session `sessionIndex` falls in, so
 * a partial session plots against the whole trading day instead of being
 * stretched across the chart width.
 */
export const getIntradaySessionWindow = (sessionIndex?: string) => {
  const sessionET = toMarketTime(sessionIndex ?? Date.now());
  const year = sessionET.getFullYear();
  const month = sessionET.getMonth();
  const day = sessionET.getDate();

  return {
    fromDate: new Date(year, month, day, 9, 30, 0, 0),
    toDate: new Date(year, month, day, 16, 0, 0, 0),
  };
};
